import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const HomeCarIcon = _ref => {
  let {
      size = "18",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: "21",
    height: "18",
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M18.1889 1.35469C17.9667 0.709375 17.3444 0.25 16.6111 0.25H4.38889C3.65556 0.25 3.04444 0.709375 2.81111 1.35469L0.5 7.90625V16.6562C0.5 17.2578 1 17.75 1.61111 17.75H2.72222C3.33333 17.75 3.83333 17.2578 3.83333 16.6562V15.5625H17.1667V16.6562C17.1667 17.2578 17.6667 17.75 18.2778 17.75H19.3889C20 17.75 20.5 17.2578 20.5 16.6562V7.90625L18.1889 1.35469ZM5.5 12.2812C4.57778 12.2812 3.83333 11.5484 3.83333 10.6406C3.83333 9.73281 4.57778 9 5.5 9C6.42222 9 7.16667 9.73281 7.16667 10.6406C7.16667 11.5484 6.42222 12.2812 5.5 12.2812ZM15.5 12.2812C14.5778 12.2812 13.8333 11.5484 13.8333 10.6406C13.8333 9.73281 14.5778 9 15.5 9C16.4222 9 17.1667 9.73281 17.1667 10.6406C17.1667 11.5484 16.4222 12.2812 15.5 12.2812ZM3.62222 5.71875L4.77778 2.4375H16.2111L17.3667 5.71875H3.62222Z",
    fill: color
  }));
};
export default HomeCarIcon;